export function submitForm({
    data,
    url,
}: {
    data: {
        [key: string]: any;
    };
    url: string;
}) {
    const formData = new FormData();

    Object.keys(data).forEach((field) => {
        formData.append(field, data[field]);
    });

    return fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
    });
}
